import api, { callRefreshToken } from "../config/http-common";

export const planList = async (payload) => {
  let url = `${process.env.REACT_APP_SERVER_URL}/plans?`;
  if (payload?.name) {
    url += `&name=${payload.name}`;
  }
  if (payload?.planOrder) {
    url += `&planOrder=${payload.planOrder}`;
  }

  if (payload?.intervalUnit) {
    url += `&intervalUnit=${payload.intervalUnit}`;
  }
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().get(url);
};

export const getFeaturesList = async () => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().get(`/features`);
};


export const getPlan = async (planName) => {
  let url = `${process.env.REACT_APP_SERVER_URL}/plans/${planName}`;
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().get(url);
}

export const createNewPlanAndFeature = async (payload) => {
  const value = await callRefreshToken();
  if (value == true)
    return api.securedAxios().post(`/plan`, payload);
};

export const updateFeature = async (mCode, yCode, payload) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxios().put(`/feature?monthlyCode=${mCode}&yearlyCode=${yCode}`, payload);
};

export const updatePlan = async (monthlyCode, yearlyCode, payload) => {
  const baseUrl = `${process.env.REACT_APP_SERVER_URL}/plan`;
  const url = `${baseUrl}?monthlyCode=${monthlyCode}&yearlyCode=${yearlyCode}`;
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().put(url, payload);
};